<template>
  <span v-tooltip="tooltipValue">{{ result }}</span>
</template>

<script>
export default {
  props: {
    value: {
      type: [String, Number],
      default: null,
    },
    type: {
      type: String,
      default: null,
    },
    showTooltip: {
      type: Boolean,
      default: false,
    },
    tooltipValue: {
      type: String,
      default: null,
    },
    locale: {
      type: String,
      default: 'en-GB',
    },
  },
  computed: {
    result() {
      return this.$func.formatter(this.value, this.type, this.locale)
    },
  },
}
</script>
